import React, { useEffect, useState } from 'react';
import { Box, Button } from 'native-base';
import { observer, GIFTCARD_FLOWS, i18nFn, useSpringBigStore, useGetGiftCardPaymentList, GiftCardPayment, useDeleteGiftCardPayment } from '@springbig/shared';
import { ActionButton } from '../ActionButton';
import { useGeneralStyles } from '~/shared/styles';
import { useToast } from '~/hooks/toast';
import { Caption } from '~/shared/Typography';

const ManagePayment = ({ t }: { t: i18nFn }) => {

    const { giftCardPaymentList, member } = useSpringBigStore();
    const giftCardPaymentListQuery = useGetGiftCardPaymentList();
    const [deleteList, setDeleteList] = useState<GiftCardPayment[]>([]);

    const gStyle = useGeneralStyles();

    const onPayemendAddPress = () => {

        observer.emit('change-screen', GIFTCARD_FLOWS.addPayment);
    };

    useEffect(() => {

        giftCardPaymentListQuery?.refetch();
    }, []);

    const paymentCards = giftCardPaymentList?.filter(
        (payment: GiftCardPayment) => payment.card_nickname
    );

    const { mutate: deleteMethod } = useDeleteGiftCardPayment();
    const { errorToast, successToast } = useToast();

    return (
        <Box justifyContent={'space-between'} flexDirection={'column'}>
            <Box>
                <Caption textAlign={'center'} fontSize={24}>{t('payment.manage_payments')}</Caption>
                <Box flexDirection={'row'}
                    alignItems={'center'}
                    flexWrap={'wrap'}
                    justifyContent={'space-between'}
                    width={'100%'}
                >
                    <Caption fontSize={18} fontWeight={500}>{t('payment.cards_on_file')}</Caption>
                    <Button
                        onPress={onPayemendAddPress}
                    >
                        <Caption
                            color={gStyle.button_background}
                            fontSize={18}
                            fontWeight={300}
                        >
                            {t('payment.new_card')}
                        </Caption>
                    </Button>
                </Box>
            </Box>
            {paymentCards &&
                paymentCards.length > 0 &&
                paymentCards.map((paymentMethod) => {
                    const { account_name, card_nickname } = paymentMethod;
                    const isDelete = !deleteList.includes(paymentMethod);
                    return (
                        <Box
                            key={`${account_name || card_nickname}-${Math.random()}`}
                            flexDirection={'row'}
                            alignItems={'center'}
                            flexWrap={'wrap'}
                            justifyContent={'space-between'}
                            width={'100%'}
                        >
                            <Caption fontSize={22} fontWeight={200}>
                                x{account_name || card_nickname}
                            </Caption>
                            {paymentCards.length > 1 && isDelete && <Button onPress={() => setDeleteList([...deleteList, paymentMethod])}>
                                <Caption
                                    color={gStyle.button_danger_background}
                                    fontSize={18}
                                    fontWeight={300}
                                >
                                    {t('payment.remove')}
                                </Caption>
                            </Button>}
                            {paymentCards.length > 1 && !isDelete && <Button onPress={() => setDeleteList([...(deleteList.filter((e) => e !== paymentMethod))])}>
                                <Caption
                                    fontSize={18}
                                    fontWeight={300}
                                >
                                    {t('payment.add')}
                                </Caption>
                            </Button>}
                        </Box>
                    );
                })}
            <ActionButton
                w={'125px'}
                m={'auto'}
                title={t('payment.save')}
                onPress={() => {
                    deleteList.forEach((selectedMethod) => {
                        deleteMethod({
                            id: selectedMethod?.id,
                            member_id: member?.id,
                        }, {
                            onSuccess() {

                                successToast('payment information successfully removed');
                                giftCardPaymentListQuery?.refetch();
                            },
                            onError() {

                                errorToast('there was an error while deleting your payment information, please contact an administrator');
                            }
                        });
                    });
                }}

            />
        </Box>
    );
};

export default ManagePayment;
